import { render, staticRenderFns } from "./posterActivitiesManage.vue?vue&type=template&id=7240f751"
import script from "./posterActivitiesManage.vue?vue&type=script&lang=js"
export * from "./posterActivitiesManage.vue?vue&type=script&lang=js"
import style0 from "./posterActivitiesManage.vue?vue&type=style&index=0&id=7240f751&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports